// In every file you need this!

// import $ from 'jquery';
// //attach jquery to dom
// window.jQuery = $;
// window.$ = $;

(function($) {
	$(document).ready(function() {
		$(".white_btn").on("click", function () {
		let button_area_top = $(".section_second_content").offset().top;
		$('body, html').animate({scrollTop: button_area_top}, 400);
		});

		$(".next_step_one").on("click", function () {
		let button_area_top = $(".fuel_card_title").offset().top;
		$('body, html').animate({scrollTop: button_area_top}, 400);
		});

		$(".next_step_two").on("click", function () {
		let button_area_top = $(".bank_details_title").offset().top;
		$('body, html').animate({scrollTop: button_area_top}, 400);
		});

		$(".quick_enquiry_button").on("click", function () {
		let button_area_top = $(".get_in_touch_banner").offset().top;
		$('body, html').animate({scrollTop: button_area_top}, 400);
		});
	});
})(jQuery);